export default () => {
	return (
		<svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M11 2.66667H13C13.1768 2.66667 13.3464 2.7369 13.4714 2.86193C13.5964 2.98695 13.6667 3.15652 13.6667 3.33333V11.3333C13.6667 11.5101 13.5964 11.6797 13.4714 11.8047C13.3464 11.9298 13.1768 12 13 12H1.00001C0.823199 12 0.65363 11.9298 0.528606 11.8047C0.403581 11.6797 0.333344 11.5101 0.333344 11.3333V0.666667C0.333344 0.489856 0.403581 0.320286 0.528606 0.195262C0.65363 0.0702379 0.823199 0 1.00001 0H11V2.66667ZM1.66668 4V10.6667H12.3333V4H1.66668ZM1.66668 1.33333V2.66667H9.66668V1.33333H1.66668ZM9.00001 6.66667H11V8H9.00001V6.66667Z"
				fill="#181833"/>
		</svg>
	)
}